export const NOTIFICATION_TYPES = {
  Default: 'default',
  Success: 'success',
  Info: 'info',
  Warning: 'warning',
  Error: 'error',
};
